<template>
  <div>
    <NodeBrokerCUD
      class="d-none"
      ref="editNodeBroker"
      @new_item="new_node_broker"
    ></NodeBrokerCUD>
    <v-card
      v-if="
        (create_node_broker || (create_first && node_brokers?.length == 0)) &&
        !loading
      "
      :loading="loading"
    >
      <v-card-title class="justify-center">
        Select A Broker To Connect
      </v-card-title>
      <v-card-text>
        <ListItems
          :pages="Math.ceil(brokers.length / brokers_per_page)"
          :items_per_page="brokers_per_page"
          :total_visible="10"
          :get_page_items="
            (page) => {
              let start = this.brokers_per_page * (page - 1);
              let end = start + 3;
              return this.brokers.slice(start, end);
            }
          "
        >
          <template v-slot:view_item="mProps">
            <v-card
              @click="$refs['editNodeBroker'].create_item(mProps.item.type)"
            >
              <v-card-text class="d-flex justify-space-around align-center">
                <div>
                  <v-img
                    :aspect-ratio="16 / 9"
                    :src="require(`@/assets/${mProps.item.img_local}`)"
                    min-width="250px"
                  >
                    <span
                      absolute
                      class="text-button pl-10"
                      style="color: white"
                      v-if="mProps.item?.short_desc"
                      >{{ mProps.item.short_desc }}</span
                    >
                  </v-img>
                </div>
                <div>
                  <v-btn>CREATE CONNECTION</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </template>
        </ListItems>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Vuex from "vuex";

import NodeBrokerCUD from "@/components/nodeBrokers/NodeBrokerCUD.vue";
import pagedFetcher from "@/mixins/pagedFetcher";
import ListItems from "@/components/helpers/ListItemsV.vue";
import instanceComandBroker from "@/mixins/instanceComandBroker.js";

import B from "@/mixins/brokerConstants.js";

export default {
  name: "NodeBrokerCreator",
  components: { NodeBrokerCUD, ListItems },
  mixins: [pagedFetcher, instanceComandBroker],
  props: {
    create_first: {
      type: Boolean,
      default: false,
    },
    create_node_broker: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      node_brokers: [],
      brokers_per_page: 3,
      brokers: B.get_brokers(),
      mock: false,
      B: B,
    };
  },
  methods: {
    async exec_command(type, command, data = {}) {
      try {
        await this.do_instance_command(type, command, data);
      } catch (error) {
        this.show_error_message(error);
      }
    },
    async new_node_broker(new_broker) {
      if (this.B.is_interactive_broker(new_broker.broker_type)) {
        this.node_broker_cmd = broker;
        this.exec_command("IBManager", "UpdateIBC").then(() => {});
      }
      this.$emit("new_broker", new_broker);
    },
    get_broker_img(broker_type) {
      return this.B.get_broker(broker_type)?.img_local;
    },
    get_url() {
      return `${this.apip.API_NODE_BROKERS_PATH}`;
    },
    async fetch_node_brokers() {
      try {
        this.loading = true;
        var response = await this.actual_fetch_data();
        this.node_brokers = response.data.results;
        this.loading = false;
      } catch (error) {
        this.show_error_message(error);
      }
    },
    ...Vuex.mapActions(["show_error_message", "show_info_message"]),
  },
  computed: {},
  watch: {
    node_brokers(nval) {
      this.$emit("node_brokers", nval);
    },
  },
  mounted() {
    this.limit = 1;
    this.fetch_node_brokers();
  },
};
</script>
